import { render, staticRenderFns } from "./GroupResultMain.vue?vue&type=template&id=44b66072&lang=html"
import script from "./GroupResultMain.vue?vue&type=script&lang=js"
export * from "./GroupResultMain.vue?vue&type=script&lang=js"
import style0 from "./GroupResultMain.vue?vue&type=style&index=0&id=44b66072&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports